module.exports = __webpack_public_path__ + "media/10_7.84cc2b03.wav";